import { Box, Text, TextButton } from '@wix/design-system';
import { Chat as ChatIcon } from '@wix/wix-ui-icons-common';
import React, { useMemo } from 'react';
import { useBi, useTranslation } from '../../hooks';
export const Feedback = _ref => {
  let {
    metaSiteId,
    invocationId
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    biClick
  } = useBi();
  const feedbackUrl = useMemo(() => {
    const url = new URL('https://www.wixcustomagent.com');
    url.searchParams.set('msid', metaSiteId);
    url.searchParams.set('invocationId', invocationId);
    return url.toString();
  }, [metaSiteId, invocationId]);
  const handleClick = () => {
    biClick({
      origin: 'give_feedback',
      entityType: 'invocation',
      entityId: invocationId
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "3px",
    backgroundColor: "B60",
    padding: "SP2",
    borderRadius: 4,
    marginTop: "SP1"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('feedback.title')), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    href: feedbackUrl,
    target: "_blank",
    size: "tiny",
    prefixIcon: /*#__PURE__*/React.createElement(ChatIcon, null),
    onClick: handleClick
  }, t('feedback.button'))));
};
//# sourceMappingURL=Feedback.js.map